import React from "react";
import { AlertOctagon, AlertTriangle, Check } from "react-feather";
import styled, { css } from "styled-components";

const StatusText = styled.span<{ $type?: string }>`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 5px;
    flex-shrink: 0;
  }

  ${(props) =>
    props.$type === "error" &&
    css`
      color: var(--red400);
    `}

  ${(props) =>
    props.$type === "warn" &&
    css`
      color: var(--orange400);
    `}

  ${(props) =>
    props.$type === "success" &&
    css`
      color: var(--green300);
    `}

  ${(props) =>
    props.$type === "placeholder" &&
    css`
      color: var(--dark700);
    `}
`;

const Status = (props: {
  children?: React.ReactNode;
  type?: "error" | "placeholder" | "warn" | "success";
  icon?: boolean;
}) => {
  const { children, type, icon } = props;
  return (
    <StatusText $type={type}>
      {icon &&
        (type === "error" ? (
          <AlertOctagon size={17} />
        ) : type === "warn" ? (
          <AlertTriangle size={17} />
        ) : type === "success" ? (
          <Check size={17} />
        ) : undefined)}
      {children}
    </StatusText>
  );
};

export default Status;
